<template>
  <div id="editorElem1" style="text-align: left"></div>
</template>

<script>
import E from "wangeditor";
export default {
  name: "Editor",
  props: {
    content: {
      type: String,
      default: "",
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editor: null,
    };
  },
  watch: {
    show(val) {
      if (val) {
        this.editor.txt.html(this.content);
      }
    },
  },
  model: {
    prop: "content",
    event: "change",
  },
  mounted() {
    this.onOpen();
  },
  methods: {
    onOpen() {
      //在编辑弹框打开的时候创建一个王编辑器
      this.editor = new E("#editorElem1");
      this.editor.config.onchange = (html) => {
        this.$emit("change", html);
      };
      this.editor.config.height = 500; //设置编辑器的高度
      this.editor.config.colors = [
        "#000000",
        "#ffffff",
        "#434343",
        "#626262",
        "#43abd4",
        "#1a4687",
        "#9fc648",
        "#007a42",
        "#37b098",
        "#e3b64c",
        "#da4637",
        "#d8315b",
        "#882a6b",
      ]; //设置编辑器的字体和背景颜色
      this.editor.config.uploadVideoAccept = ["mp4", "MP4", "MOV", "mov"];
      var that = this;
      // 手动配置粘贴时的内容处理方法
      // 给粘贴的内容外侧包裹上与光标位置相同的样式标签，从而使粘贴后的内容样式与前后相同
      this.editor.config.pasteTextHandle = function (pasteStr) {
        // chrome会给纯文本加上<p>标签，先去除掉以获取纯内容
        let rawText;
        if (pasteStr.startsWith("<p>") && pasteStr.endsWith("</p>")) {
          rawText = pasteStr.substring(3, pasteStr.length - 4);
        } else {
          rawText = pasteStr;
        }
        // 获取光标选取节点
        let selection =
          that.editor.selection.getSelectionContainerElem().elems[0];
        // 遍历父节点，直至遇到最外层的标签（如p、h1等），所有遍历的节点按顺序入栈
        let stack = [];
        let _curr = selection;
        while (!["P", "H1", "H2", "H3", "H4", "H5"].includes(_curr.nodeName)) {
          stack.push(_curr);
          _curr = _curr.parentNode;
        }
        // 根据栈，给粘贴的文本逐级添加样式标签
        let _result = rawText;
        stack.forEach((item) => {
          // 构建字符串形式的attribute
          let attrStr = "";
          item.attributes.forEach((attr) => {
            attrStr += ` ${attr.nodeName}="${attr.value}"`;
          });
          // 标签名称
          let name = item.nodeName.toLowerCase();
          _result = `<${name}${attrStr}>${_result}</${name}>`;
        });
        return _result;
      };
      this.editor.config.customUploadImg = (files, insert) => {
        files.forEach((image) => {
          let data = new FormData();
          data.append("file", image);
          this.$axios.post("/oss/upload", data).then((res) => {
            if (res.code == 200) {
              insert(res.data);
            }
          });
        });
      }; //这个编辑器需要处理下后台上传的接口，将需要上传的文件返回到编辑器中
      //上传视频
      // this.editor.config.uploadVideoServer = "/travel/oss/upload"; // 上传接口
      this.editor.config.customUploadVideo = (files, insert) => {
        files.forEach((video) => {
          let data = new FormData();
          data.append("file", video);
          this.$notify({
            title: "上传视频中，请耐心等待...",
          });
          this.$axios.post("/oss/upload", data).then((res) => {
            if (res.code == 200) {
              this.$notify({
                title: "上传成功",
              });
              insert(res.data);
            }
          });
        });
      };
      this.editor.create(); //创建编辑器
      if (!this.content) {
        this.editor.txt.clear();
      } else {
        this.editor.txt.html(this.content);
      }
    },
  },
};
</script>

<style>
.editor,
.ql-toolbar {
  white-space: pre-wrap !important;
  line-height: normal !important;
}
.quill-img {
  display: none;
}
.ql-snow .ql-tooltip[data-mode="link"]::before {
  content: "请输入链接地址:";
}
.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
  border-right: 0px;
  content: "保存";
  padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode="video"]::before {
  content: "请输入视频地址:";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: "14px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="small"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="small"]::before {
  content: "10px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="large"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="large"]::before {
  content: "18px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="huge"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="huge"]::before {
  content: "32px";
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: "文本";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: "标题1";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: "标题2";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: "标题3";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: "标题4";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: "标题5";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: "标题6";
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: "标准字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
  content: "衬线字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
  content: "等宽字体";
}
</style>